<div class="flex-auto">
  <label *ngIf="showLabel" class="block font-semibold mb-2">
    <span class="mr-1">{{ label }}</span>
    <span *ngIf="checkRequire()" class="text-danger">*</span>
  </label>
  <p-datePicker
    [showTime]="showTime"
    [formControl]="control"
    [minDate]="_minDate"
    [maxDate]="_maxDate"
    [timeOnly]="timeOnly"
    [hourFormat]="hourFormat"
    dateFormat="dd/mm/yy"
    styleClass="w-full"
    appendTo="body"
  ></p-datePicker>
  <div class="validator-errors">
    <small *ngIf="errors" class="error-msg block fadeinup animation-duration-300">
      <span class="block text-danger">{{ getError().key | translate: getError().required }}</span>
    </small>
  </div>
</div>
